import React, { useState, useEffect, useRef, useReducer } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from 'react-router';
import CrcAccordin from '../../../components/crcAccordin';
import './styles.css';
import { createGenInfoRequestSubmit, createGenInfoRequestSave } from '../../../modules/checkListGenerator/store/actions/index';
import { CommonConfig } from '../../../config/common-config';
import { userType } from '../../../config/usertypeValue';
import TabList from '../../../components/checklistTab/tabList';

const useStyles = makeStyles({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
    },
    paperGreen: {
        padding: '16px',
        textAlign: 'center',
        borderBottom: '4px solid green',
    },
    paperOrange: {
        padding: '16px',
        textAlign: 'center',
        borderBottom: '4px solid orange',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },

    pos: {
        marginBottom: 12,
    },
    cardCustom: {
        padding: '0 !important',
    },
    fullWidth: {
        width: '100%',
        marginTop: '5%',
        position: 'fixed',
        left: '0',
        bottom: '0',
    },
    mb20: {
        marginBottom: '20px',
    },
});

export default function CrcCheckList(props) {
    const classes = useStyles();
    const accordionref = useRef();
    const [page, setPage] = useState(1);
    const [response, setResponse] = useState('');

    const servicesID = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const [checklist, setChecklist] = useState('');
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;
    const statusId = checklist && checklist.currentStage && checklist.currentStage.id;

    // const userState = useSelector((state) => state);

    //console.log("imcNameSelected:", imcNameSelected);
    //console.log("servicesID:",servicesID);
    const history = useHistory();

    const scrollTop = () => {
        accordionref.current.scrollIntoView();
    };

    const subHeader = () => {
        // return "Service ID : " + servicesID;
    }

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${imcNameSelected}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                // scrollTop();
                setResponse(response.data);
            })
            .catch((error) => { });
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${tennantnameValue}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setChecklist(response.data);
            })
            .catch((error) => { });
    }, [props]);

    const navigateChecklist = (path, typeValue) => {
        //console.log('userType,statusId', userType, statusId)
        userType.value = typeValue;
        // history.push(path);

    }

    return (
        <>
            <div ref={accordionref}>
                {/* <div className="stage-indicator">
                    <ul>
                        {usertype === 'Itec Team' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className="active">L1 CRC Confirmed</li>
                            </ul>
                        ) : (
                            ''
                        )}
                        {usertype === 'ITeC AM and above' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} >L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className="active">L1 AM Confirmed</li>
                            </ul>
                        ) : (
                            ''
                        )}
                        {usertype === 'EM' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}>L1 AM Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className="active">EM Confirmed</li>
                            </ul>
                        ) : (
                            ''
                        )}
                    </ul>
                </div> */}

                <TabList />

                <Card className={classes.root}>
                    <CardContent className={classes.cardCustom}>
                        {/* {usertype === 'Itec Team' ? <CardHeader className="borderBottomLine title-padding" title="L1 CRC Confirmed" subheader={subHeader()} /> : ''}
                        {usertype === 'EM' ? <CardHeader className="borderBottomLine title-padding" title="EM Confirmed" subheader={subHeader()} /> : ''}
                        {usertype === 'ITeC AM and above' ? (
                            <CardHeader className="borderBottomLine title-padding" title="L1 AM Confirmed" subheader={subHeader()} />
                        ) : (
                                ''
                            )} */}
                        <CrcAccordin page={page} />
                    </CardContent>
                </Card>
            </div>
        </>
    );
}
